(function () {
	const productSlider = () => {
		$(".js-get-section").each(function (index, parent) {
			let carousel = parent.querySelector(".js-swiper-product-carousel");
			if (!carousel || carousel.classList.contains("swiper-initialized")) return;

			let scrollBar = parent.querySelector(".js-product-carousel-swiper-scrollbar");
			let prev = parent.querySelector(".js-product-carousel-arrow-prev");
			let next = parent.querySelector(".js-product-carousel-arrow-next");

			new Swiper(carousel, {
				slidesPerView: 1.2,
				spaceBetween: 20,
				slidesOffsetAfter: 20,
				scrollbar: {
					el: scrollBar,
					draggable: true,
				},
				navigation: {
					prevEl: prev,
					nextEl: next,
				},
				breakpoints: {
					750: { slidesPerView: 1.2, spaceBetween: 20, slidesOffsetAfter: 0 },
					990: { slidesPerView: 2, spaceBetween: 24, slidesOffsetAfter: 0 },
					1200: { slidesPerView: 3, spaceBetween: 24, slidesOffsetAfter: 0 },
				},
			});

			if (
				$(prev).hasClass("swiper-button-lock") ||
				$(next).hasClass("swiper-button-lock")
			) {
				$(parent).find(".product-carousel_nav-tools").css("display", "none");
			}
		});

		if (window.initProductCardSlider) {
			window.initProductCardSlider();
		}
	};

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", productSlider);
	} else {
		productSlider();
	}

	document.addEventListener("shopify:section:load", function () {
		productSlider();
	});
})();
